import { render, staticRenderFns } from "./ClubDetail.vue?vue&type=template&id=14aa267e&scoped=true&"
import script from "./ClubDetail.vue?vue&type=script&lang=js&"
export * from "./ClubDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClubDetail.vue?vue&type=style&index=0&id=14aa267e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa267e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
